<!-- Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. -->

<div class="ticket-quick-status-prompt-container" [planPositioning]="menuData$">
	<!-- 
		ugh, material... to open a menu, it requires another dom element with matMenuTriggerFor to get access to the
		trigger.openMenu method. Soo... instead of a button, have a 0x0 div I guess.
	-->
	<div #contextMenuTrigger="matMenuTrigger" [matMenuTriggerFor]="contextMenu"></div>

	<mat-menu #contextMenu="matMenu" class="context-menu" [hasBackdrop]="false">
		<button
			mat-menu-item
			(click)="onMarkAsStartedClicked()"
			automationId="markAsStarted"
			[disabled]="disableMarkAsStarted"
			*ngIf="!hideMarkAsStarted"
		>
			<mat-icon color="primary">play_arrow</mat-icon>{{ markAsStartedStr }}
		</button>
		<button mat-menu-item (click)="completeAsPlannedClicked()" automationId="completeAsPlanned">
			<mat-icon color="primary">check_circle</mat-icon>{{ completeAsPlannedStr }}
		</button>
		<button
			mat-menu-item
			(click)="completeWithChanges()"
			[disabled]="disableCompleteWithChanges"
			automationId="completeWithChanges"
		>
			<mat-icon color="primary">mode_edit</mat-icon>{{ completeWithChangesStr }}
		</button>
	</mat-menu>
</div>
